import { render, staticRenderFns } from "./ProfessorProgressionReport.vue?vue&type=template&id=76e2c0a6&scoped=true"
import script from "./ProfessorProgressionReport.vue?vue&type=script&lang=js"
export * from "./ProfessorProgressionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e2c0a6",
  null
  
)

export default component.exports